import React, {Component} from 'react';
import InspectionsHeader from './inspections-header';
import InspectionsBody from './inspections-body';
import InspectionsFooter from './inspections-footer';
import {bindActionCreators} from 'redux'
import InspectionDetailAction from '../../../../redux/actions/inspection';
import InspectionsAction from '../../../../redux/actions/inspections';
import {connect} from 'react-redux'
import '../../../../styles/ui-form.css';
import {INSPECTION_STATE} from '../../../../constants/app/inspection';
import ModalChangeToPresential from '../inspection/components/change-to-presential/modal-change-to-presential';
import {STATUS_SERVICE} from '../../../../constants/app/services';

class Inspections extends Component {
    constructor(props) {
        super(props);

        this.state = {
            objSearch: {
                searchValue: '',
                searchFilter: '',
                size: 10,
                page: 0,
                states: ''
            },
            isFiltered: false,
            allInspections: [],
            openModal: false,
            title: '',
            text: '',
            userIdentity: '',
            requestId: ''
        }
    }

    componentDidMount = () => {
        this.props.load(0, 10, Object.keys(INSPECTION_STATE).join(','), 'NONE');
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.inspections.length) {
            this.setState({allInspections: this.props.inspections})
        }
    }

    componentDidUpdate = () => {
        const {isFiltered} = this.state;


        console.log(this.props.presencial);
        if (this.props.presencial === STATUS_SERVICE.SUCCESS) {
            this.props.presencialInspectionReset();
            this.props.load(0, 10, Object.keys(INSPECTION_STATE).join(','), 'NONE');
            this.setState({openModal: false});
        }
        if (isFiltered) {
            this.setState({allInspections: this.props.inspections, isFiltered: false})
        }
    };

    handleChange = (e) => {
        const {objSearch} = this.state;
        const aux = {...objSearch};

        aux[e.target.id] = e.target.value;
        if (e.target.id === 'searchFilter' && objSearch.searchValue.length) {
            aux.searchValue = '';
            this.setState({objSearch: aux});
        } else {
            this.setState({objSearch: aux});
        }
    };

    goFilter = () => {
        const {objSearch} = this.state;
        if (objSearch.states === '') {
            objSearch.states = Object.keys(INSPECTION_STATE).join(',')
        }
        this.setState({isFiltered: true});
        this.props.changeState(objSearch);
    };

    openModalChangeToInspection = (inspection) => {
        const {openModal} = this.state;

        this.setState({
            openModal: !openModal,
            title: inspection.title,
            text: inspection.text,
            userIdentity: inspection.userIdentity,
            requestId: inspection.requestId
        });
    };

    handlePresential = () => {
        const {userIdentity, requestId, objSearch} = this.state;
        const aux = {...objSearch};
        aux.states = '';
        const body = {
            dayleft: 0,
            send: false
        };
        if (userIdentity && requestId) {
            this.props.presencialInspection(userIdentity, requestId, body);
        }
    };

    handleRemoveInspections = () => {
        const inspectionsArray = [
            {
                requestId: Number(this.state.requestId),
                userIdentity: this.state.userIdentity,
            }
        ];
        this.props.removeInspections(inspectionsArray);
        this.setState({openModal: false});
        window.location.reload();
    };

    render() {
        const {objSearch, openModal, title, allInspections, text} = this.state;
        const {isViewer} = this.props;
        return (
            <div>
                <div className="ui-form pt60">
                    <div className="bg-top bh250"/>
                    <div className="ui-container">
                        <div className="ui-content">
                            <div className="Dashboard-inspections">
                                <InspectionsHeader searchFilter={objSearch.searchFilter}
                                                   searchValue={objSearch.searchValue}
                                                   handleChange={this.handleChange}
                                                   handleFilter={this.goFilter}
                                                   filterSelected={objSearch.searchFilter}
                                                   presencial={this.props.presencial}/>
                                <InspectionsBody {...this.props}
                                                 allInspections={this.state.allInspections}
                                                 openModalChangeToInspection={this.openModalChangeToInspection}
                                                 isViewer={isViewer}/>
                                <InspectionsFooter {...this.props} />
                            </div>
                        </div>
                    </div>
                </div>
                <ModalChangeToPresential open={openModal} handleClose={this.openModalChangeToInspection}
                                         title={title}
                                         text={text}
                                         presencial={this.props.presencial}
                                         handlePresential={this.handlePresential}
                                         handleRemoveInspection={this.handleRemoveInspections}/>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    statusService: state.InspectionsReducer.statusService,
    inspections: state.InspectionsReducer.inspections,
    total: state.InspectionsReducer.total,
    page: state.InspectionsReducer.page,
    presencial: state.InspectionDetailReducer.status.presencial
});

const mapDispatchToProps = (dispatch, ownProps) => bindActionCreators({
    resetValues: InspectionsAction.resetValues,
    changeState: InspectionsAction.changeState,
    changePageNext: InspectionsAction.changePageNext,
    changePageBack: InspectionsAction.changePageBack,
    presencialInspection: InspectionDetailAction.presencialInspection,
    presencialInspectionReset: InspectionDetailAction.presencialInspectionReset,
    removeInspections: InspectionDetailAction.removeInspections,
    load: InspectionsAction.load
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Inspections);



// WEBPACK FOOTER //
// ./src/components/app/dashboard/inspections/inspections.js